import React from 'react';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import EventsByIDBlock from '../../components/EventsByIDBlock';
import PageLayout from '../../components/PageLayout';

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function OrganizerEventsByID(props) {
    let { id } = useParams();
    const { auth } = props;
    const sourceKey = "org";

    return (
        <PageLayout hideSider={true}>
            <EventsByIDBlock auth={auth} id={id} sourceKey={sourceKey} />
        </PageLayout>
    );
}
